/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useMemo, useState } from "react";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", short: "EN", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "it", label: "Italiano", short: "IT", flag: "\u{1F1EE}\u{1F1F9}" },
  { code: "zh-hans", label: "简体中文", short: "中文", flag: "\u{1F1E8}\u{1F1F3}" },
  { code: "de", label: "Deutsch", short: "DE", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "ru", label: "Русский", short: "RU", flag: "\u{1F1F7}\u{1F1FA}" },
];

const copy = {
  en: {
    about: "About us",
    aboutWhoTitle: "Eco Bambù: Who are we",
    aboutWhoText: "Eco Bambù is a manufacturer and wholesaler specializing in scarves, made from high-quality materials such as wool, cashmere, linen, micromodal, silk and silk-cotton. Our experience and dedication to quality make us the ideal partner for retailers and professionals in the fashion industry.",
    aboutProductsTitle: "Our products",
    aboutProductsIntro: "We offer a full range of scarves for all seasons:",
    aboutProductsWinter: "Winter Scarves: Made of wool and cashmere, for optimal comfort and protection.",
    aboutProductsSummer: "Summer Scarves: Lightweight and breathable, in linen, micromodal, silk and silk-cotton, ideal for a touch of summer elegance.",
    aboutWhereTitle: "Where are we",
    aboutHoursTitle: "Open hours",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    cart: "Cart",
    addToCart: "Add to cart",
    addedToCart: "Added to cart",
    cartEmpty: "Your cart is empty.",
    loginToViewCart: "Please log in to view your cart.",
    requestPurchase: "Request purchase",
    cartNote: "We currently do not support online order placement.",
    contactUsHere: "Click here to contact us.",
    products: "Products",
    contact: "Contact",
    collection: "Our collection",
    explore: "Explore",
    featured: "Featured pieces",
    viewAll: "View all products",
    moreInformation: "Need more information?",
    talkToUs: "Talk to us",
    all: "All",
    allProducts: "All products",
    filters: "Collections",
    noProducts: "No products match this collection yet.",
    loading: "Loading…",
    retry: "Try again",
    article: "Art.",
    priceOnRequest: "Price on request",
    madeInItaly: "Made in Italy",
    composition: "Composition",
    color: "Colour",
    similar: "You may also like",
    orderInfo: "Ask about this product",
    newsletter: "Newsletter",
    newsletterCopy: "Occasional product news, sent thoughtfully.",
    subscribe: "Subscribe",
    email: "Email address",
    subscribed: "Thank you for subscribing.",
    legal: "Legal",
    howToOrder: "How to order",
    howToOrderTitle: "Thanks for choosing us",
    howToOrderText: "You can choose to send images, videos, or names of the interesting products via Email, WeChat, or WhatsApp.",
    howToOrderContact: "To add our contact, please click",
    privacy: "Privacy policy",
    cookies: "Cookie policy",
    terms: "Terms and conditions",
    cookieMessage: "We use necessary storage to remember your preferences. Optional analytics can be enabled with your consent.",
    essentialOnly: "Necessary only",
    acceptAll: "Accept optional",
    logIn: "Log in",
    signUp: "Sign up",
    logOut: "Log out",
    username: "Username",
    usernameOrEmail: "Username or email",
    password: "Password",
    confirmPassword: "Confirm password",
    forgotPassword: "Forgot password?",
    createAccount: "Create new account",
    alreadyHaveAccount: "Already have an account? Log in",
    invalidCredentials: "Invalid username or password.",
    signupError: "Could not create account. Please try again.",
    resetPassword: "Reset password",
    resetDescription: "Enter your email address and we will send you a link to reset your password.",
    sendResetLink: "Send reset link",
    resetEmailSent: "If an account with that email exists, a reset link has been sent.",
    resetError: "Could not send reset email. Please try again.",
    backToLogin: "Back to login",
    passwordReset: "Password reset",
    passwordResetSuccess: "Your password has been reset. You can now log in.",
    resetLinkInvalid: "This reset link is invalid or has expired.",
    confirmEmail: "Confirm email",
    emailConfirmed: "Your email has been confirmed.",
    confirmEmailInvalid: "This confirmation link is invalid or has expired.",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    passwordChanged: "Your password has been changed.",
    passwordChangeError: "Could not change password. Please try again.",
    myAccount: "My account",
    personalData: "Personal data",
    firstName: "First name",
    lastName: "Last name",
    phone: "Phone",
    billingInformation: "Billing information",
    country: "Country",
    address: "Address",
    city: "City",
    stateProvince: "State / Province",
    postalCode: "Postal code",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    saveError: "Could not save. Please try again.",
    loadError: "Could not load data.",
    wishlist: "Wishlist",
    wishlistEmpty: "Your wishlist is empty.",
    shippingAddress: "Shipping address",
    addAddress: "Add address",
    setDefault: "Set as default",
    default: "Default",
    noAddresses: "No shipping addresses yet.",
    orders: "Orders",
    orderDetail: "Order details",
    noOrders: "No orders yet.",
    billingAddress: "Billing address",
    paymentMethod: "Payment method",
    status: "Status",
    orderSummary: "Order summary",
    subtotal: "Subtotal",
    tax: "Tax",
    shippingCost: "Shipping",
    total: "Total",
    name: "Name",
    cms: "CMS",
    productList: "Products",
    createProduct: "Create product",
    editProduct: "Edit product",
    productAttributes: "Attributes",
    orderManagement: "Orders",
    productCode: "Product code",
    retailPrice: "Retail price",
    wholesalePrice: "Wholesale price",
    priority: "Priority",
    category: "Category",
    categories: "Categories",
    subcategory: "Subcategory",
    chooseCategory: "Choose category",
    pricePublic: "Price visible",
    compositions: "Compositions",
    addComposition: "Add composition",
    description: "Description",
    images: "Images",
    addImages: "Add images",
    checkAvailability: "Check availability",
    available: "Available",
    spuTaken: "Already in use",
    update: "Update",
    create: "Create",
    confirmDelete: "Are you sure you want to delete this?",
    search: "Search",
    searchBySpu: "Search by product code",
    searchByOrderNumber: "Search by order number",
    orderNumber: "Order number",
    date: "Date",
    actions: "Actions",
    colors: "Colors",
    code: "Code",
    fieldRequired: "This field is required.",
    spuInvalid: "Only letters and numbers allowed.",
    nameInvalid: "Only - ( ) . , special characters allowed.",
    priceInvalid: "Enter a valid price.",
    imageRequired: "Upload at least one image.",
    oneCoverOnly: "Only one cover image allowed.",
    checkout: "Checkout",
    proceedToCheckout: "Proceed to checkout",
    completeBilling: "Please complete your billing information in personal data.",
    creditDebitCard: "Credit / Debit Card",
    bankTransfer: "Bank Transfer",
    cardDetails: "Card details",
    bankTransferInfo: "After placing your order, you will receive bank transfer instructions via email.",
    placeOrder: "Place order",
    paymentError: "Could not initialize payment. Please try again.",
    orderSuccess: "Your order has been placed successfully.",
  },
  it: {
    about: "Chi siamo",
    aboutWhoTitle: "Eco Bambù: Chi siamo",
    aboutWhoText: "Eco Bambù è un produttore e grossista specializzato in sciarpe, realizzate con materiali di alta qualità come lana, cashmere, lino, micromodal, seta e seta-cotone. La nostra esperienza e dedizione alla qualità ci rendono il partner ideale per rivenditori e professionisti del settore moda.",
    aboutProductsTitle: "I nostri prodotti",
    aboutProductsIntro: "Offriamo una gamma completa di sciarpe per tutte le stagioni:",
    aboutProductsWinter: "Sciarpe invernali: In lana e cashmere, per un comfort e una protezione ottimali.",
    aboutProductsSummer: "Sciarpe estive: Leggere e traspiranti, in lino, micromodal, seta e seta-cotone, ideali per un tocco di eleganza estiva.",
    aboutWhereTitle: "Dove siamo",
    aboutHoursTitle: "Orari di apertura",
    monday: "Lunedì",
    tuesday: "Martedì",
    wednesday: "Mercoledì",
    thursday: "Giovedì",
    friday: "Venerdì",
    saturday: "Sabato",
    sunday: "Domenica",
    cart: "Carrello",
    addToCart: "Aggiungi al carrello",
    addedToCart: "Aggiunto al carrello",
    cartEmpty: "Il tuo carrello è vuoto.",
    loginToViewCart: "Accedi per vedere il carrello.",
    requestPurchase: "Richiedi acquisto",
    cartNote: "Attualmente non supportiamo ordini online.",
    contactUsHere: "Clicca qui per contattarci.",
    products: "Prodotti",
    contact: "Contatti",
    collection: "La nostra collezione",
    explore: "Scopri",
    featured: "Prodotti in evidenza",
    viewAll: "Vedi tutti i prodotti",
    moreInformation: "Hai bisogno di informazioni?",
    talkToUs: "Contattaci",
    all: "Tutti",
    allProducts: "Tutti i prodotti",
    filters: "Collezioni",
    noProducts: "Non ci sono ancora prodotti in questa collezione.",
    loading: "Caricamento…",
    retry: "Riprova",
    article: "Art.",
    priceOnRequest: "Prezzo su richiesta",
    madeInItaly: "Made in Italy",
    composition: "Composizione",
    color: "Colore",
    similar: "Potrebbe piacerti anche",
    orderInfo: "Richiedi informazioni",
    newsletter: "Newsletter",
    newsletterCopy: "Novità sui prodotti, solo quando vale la pena.",
    subscribe: "Iscriviti",
    email: "Indirizzo email",
    subscribed: "Grazie per l'iscrizione.",
    legal: "Informazioni legali",
    howToOrder: "Come ordinare",
    howToOrderTitle: "Grazie per averci scelto",
    howToOrderText: "Puoi scegliere di inviare immagini, video o nomi dei prodotti che ti interessano tramite Email, WeChat o WhatsApp.",
    howToOrderContact: "Per aggiungere il nostro contatto, clicca su",
    privacy: "Privacy policy",
    cookies: "Cookie policy",
    terms: "Termini e condizioni",
    cookieMessage: "Utilizziamo la memoria necessaria per ricordare le preferenze. Le analisi opzionali richiedono il consenso.",
    essentialOnly: "Solo necessari",
    acceptAll: "Accetta opzionali",
    logIn: "Accedi",
    signUp: "Registrati",
    logOut: "Esci",
    username: "Nome utente",
    usernameOrEmail: "Nome utente o email",
    password: "Password",
    confirmPassword: "Conferma password",
    forgotPassword: "Password dimenticata?",
    createAccount: "Crea un nuovo account",
    alreadyHaveAccount: "Hai già un account? Accedi",
    invalidCredentials: "Nome utente o password non validi.",
    signupError: "Impossibile creare l'account. Riprova.",
    resetPassword: "Reimposta password",
    resetDescription: "Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password.",
    sendResetLink: "Invia link di reset",
    resetEmailSent: "Se esiste un account con questa email, è stato inviato un link di reset.",
    resetError: "Impossibile inviare l'email di reset. Riprova.",
    backToLogin: "Torna al login",
    passwordReset: "Password reimpostata",
    passwordResetSuccess: "La tua password è stata reimpostata. Ora puoi accedere.",
    resetLinkInvalid: "Questo link di reset non è valido o è scaduto.",
    confirmEmail: "Conferma email",
    emailConfirmed: "La tua email è stata confermata.",
    confirmEmailInvalid: "Questo link di conferma non è valido o è scaduto.",
    changePassword: "Cambia password",
    currentPassword: "Password attuale",
    newPassword: "Nuova password",
    passwordChanged: "La tua password è stata cambiata.",
    passwordChangeError: "Impossibile cambiare la password. Riprova.",
    myAccount: "Il mio account",
    personalData: "Dati personali",
    firstName: "Nome",
    lastName: "Cognome",
    phone: "Telefono",
    billingInformation: "Dati di fatturazione",
    country: "Paese",
    address: "Indirizzo",
    city: "Città",
    stateProvince: "Provincia",
    postalCode: "CAP",
    edit: "Modifica",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    saveError: "Impossibile salvare. Riprova.",
    loadError: "Impossibile caricare i dati.",
    wishlist: "Lista desideri",
    wishlistEmpty: "La tua lista desideri è vuota.",
    shippingAddress: "Indirizzo di spedizione",
    addAddress: "Aggiungi indirizzo",
    setDefault: "Imposta come predefinito",
    default: "Predefinito",
    noAddresses: "Nessun indirizzo di spedizione.",
    orders: "Ordini",
    orderDetail: "Dettaglio ordine",
    noOrders: "Nessun ordine.",
    billingAddress: "Indirizzo di fatturazione",
    paymentMethod: "Metodo di pagamento",
    status: "Stato",
    orderSummary: "Riepilogo ordine",
    subtotal: "Subtotale",
    tax: "IVA",
    shippingCost: "Spedizione",
    total: "Totale",
    name: "Nome",
    cms: "CMS",
    productList: "Prodotti",
    createProduct: "Crea prodotto",
    editProduct: "Modifica prodotto",
    productAttributes: "Attributi",
    orderManagement: "Ordini",
    productCode: "Codice prodotto",
    retailPrice: "Prezzo al dettaglio",
    wholesalePrice: "Prezzo all'ingrosso",
    priority: "Priorità",
    category: "Categoria",
    categories: "Categorie",
    subcategory: "Sottocategoria",
    chooseCategory: "Scegli categoria",
    pricePublic: "Prezzo visibile",
    compositions: "Composizioni",
    addComposition: "Aggiungi composizione",
    description: "Descrizione",
    images: "Immagini",
    addImages: "Aggiungi immagini",
    checkAvailability: "Verifica disponibilità",
    available: "Disponibile",
    spuTaken: "Già in uso",
    update: "Aggiorna",
    create: "Crea",
    confirmDelete: "Sei sicuro di voler eliminare?",
    search: "Cerca",
    searchBySpu: "Cerca per codice prodotto",
    searchByOrderNumber: "Cerca per numero ordine",
    orderNumber: "Numero ordine",
    date: "Data",
    actions: "Azioni",
    colors: "Colori",
    code: "Codice",
    fieldRequired: "Campo obbligatorio.",
    spuInvalid: "Solo lettere e numeri.",
    nameInvalid: "Solo - ( ) . , come caratteri speciali.",
    priceInvalid: "Inserire un prezzo valido.",
    imageRequired: "Caricare almeno un'immagine.",
    oneCoverOnly: "È consentita una sola immagine di copertina.",
    checkout: "Checkout",
    proceedToCheckout: "Procedi al checkout",
    completeBilling: "Completa le informazioni di fatturazione nei dati personali.",
    creditDebitCard: "Carta di credito / debito",
    bankTransfer: "Bonifico bancario",
    cardDetails: "Dati della carta",
    bankTransferInfo: "Dopo aver effettuato l'ordine, riceverai le istruzioni per il bonifico via email.",
    placeOrder: "Effettua ordine",
    paymentError: "Impossibile inizializzare il pagamento. Riprova.",
    orderSuccess: "Il tuo ordine è stato effettuato con successo.",
  },
  "zh-hans": {
    about: "关于我们",
    aboutWhoTitle: "Eco Bambù：我们是谁",
    aboutWhoText: "Eco Bambù是一家专业生产和批发围巾的企业，采用羊毛、羊绒、亚麻、微模态纤维、丝绸和丝棉等优质材料。我们的经验和对品质的追求使我们成为时尚行业零售商和专业人士的理想合作伙伴。",
    aboutProductsTitle: "我们的产品",
    aboutProductsIntro: "我们提供适合各季节的全系列围巾：",
    aboutProductsWinter: "冬季围巾：采用羊毛和羊绒制成，提供最佳舒适度和保暖性。",
    aboutProductsSummer: "夏季围巾：轻薄透气，采用亚麻、微模态纤维、丝绸和丝棉制成，为夏日增添优雅。",
    aboutWhereTitle: "我们的位置",
    aboutHoursTitle: "营业时间",
    monday: "周一",
    tuesday: "周二",
    wednesday: "周三",
    thursday: "周四",
    friday: "周五",
    saturday: "周六",
    sunday: "周日",
    cart: "购物车",
    addToCart: "加入购物车",
    addedToCart: "已加入购物车",
    cartEmpty: "您的购物车为空。",
    loginToViewCart: "请登录查看购物车。",
    requestPurchase: "请求购买",
    cartNote: "目前我们不支持在线下单。",
    contactUsHere: "点击此处联系我们。",
    products: "产品",
    contact: "联系方式",
    collection: "我们的系列",
    explore: "探索",
    featured: "精选",
    viewAll: "查看全部",
    moreInformation: "需要更多信息？",
    talkToUs: "联系我们",
    all: "全部",
    allProducts: "全部产品",
    filters: "分类",
    noProducts: "该分类暂无产品。",
    loading: "加载中…",
    retry: "重试",
    article: "货号",
    priceOnRequest: "价格请询",
    madeInItaly: "意大利制造",
    composition: "成分",
    color: "颜色",
    similar: "您可能还喜欢",
    orderInfo: "咨询此产品",
    newsletter: "通讯",
    newsletterCopy: "不定期发送产品新闻。",
    subscribe: "订阅",
    email: "邮箱地址",
    subscribed: "感谢您的订阅。",
    legal: "法律信息",
    howToOrder: "如何订购",
    howToOrderTitle: "感谢您选择我们",
    howToOrderText: "您可以通过邮件、微信或WhatsApp发送您感兴趣的产品图片、视频或名称。",
    howToOrderContact: "添加我们的联系方式，请点击",
    privacy: "隐私政策",
    cookies: "Cookie政策",
    terms: "条款和条件",
    cookieMessage: "我们使用必要的存储来记住您的偏好。可选的分析功能需要您的同意。",
    essentialOnly: "仅必要",
    acceptAll: "接受可选",
    logIn: "登录",
    signUp: "注册",
    logOut: "退出",
    username: "用户名",
    usernameOrEmail: "用户名或邮箱",
    password: "密码",
    confirmPassword: "确认密码",
    forgotPassword: "忘记密码？",
    createAccount: "创建新账户",
    alreadyHaveAccount: "已有账户？登录",
    invalidCredentials: "用户名或密码无效。",
    signupError: "无法创建账户，请重试。",
    resetPassword: "重置密码",
    resetDescription: "输入您的邮箱地址，我们将发送重置链接。",
    sendResetLink: "发送重置链接",
    resetEmailSent: "如果该邮箱存在账户，已发送重置链接。",
    resetError: "无法发送重置邮件，请重试。",
    backToLogin: "返回登录",
    passwordReset: "密码已重置",
    passwordResetSuccess: "您的密码已重置，现在可以登录。",
    resetLinkInvalid: "此重置链接无效或已过期。",
    confirmEmail: "确认邮箱",
    emailConfirmed: "您的邮箱已确认。",
    confirmEmailInvalid: "此确认链接无效或已过期。",
    changePassword: "修改密码",
    currentPassword: "当前密码",
    newPassword: "新密码",
    passwordChanged: "您的密码已修改。",
    passwordChangeError: "无法修改密码，请重试。",
    myAccount: "我的账户",
    personalData: "个人资料",
    firstName: "名",
    lastName: "姓",
    phone: "电话",
    billingInformation: "账单信息",
    country: "国家",
    address: "地址",
    city: "城市",
    stateProvince: "省/州",
    postalCode: "邮编",
    edit: "编辑",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    saveError: "保存失败，请重试。",
    loadError: "无法加载数据。",
    wishlist: "收藏夹",
    wishlistEmpty: "您的收藏夹为空。",
    shippingAddress: "收货地址",
    addAddress: "添加地址",
    setDefault: "设为默认",
    default: "默认",
    noAddresses: "暂无收货地址。",
    orders: "订单",
    orderDetail: "订单详情",
    noOrders: "暂无订单。",
    billingAddress: "账单地址",
    paymentMethod: "支付方式",
    status: "状态",
    orderSummary: "订单摘要",
    subtotal: "小计",
    tax: "税费",
    shippingCost: "运费",
    total: "合计",
    name: "姓名",
    cms: "CMS",
    productList: "产品列表",
    createProduct: "创建产品",
    editProduct: "编辑产品",
    productAttributes: "属性",
    orderManagement: "订单管理",
    productCode: "产品代码",
    retailPrice: "零售价",
    wholesalePrice: "批发价",
    priority: "优先级",
    category: "分类",
    categories: "分类",
    subcategory: "子分类",
    chooseCategory: "选择分类",
    pricePublic: "价格可见",
    compositions: "成分",
    addComposition: "添加成分",
    description: "描述",
    images: "图片",
    addImages: "添加图片",
    checkAvailability: "检查可用性",
    available: "可用",
    spuTaken: "已被使用",
    update: "更新",
    create: "创建",
    confirmDelete: "确定要删除吗？",
    search: "搜索",
    searchBySpu: "按产品代码搜索",
    searchByOrderNumber: "按订单号搜索",
    orderNumber: "订单号",
    date: "日期",
    actions: "操作",
    colors: "颜色",
    code: "代码",
    fieldRequired: "此字段为必填。",
    spuInvalid: "仅允许字母和数字。",
    nameInvalid: "仅允许 - ( ) . , 特殊字符。",
    priceInvalid: "请输入有效价格。",
    imageRequired: "请至少上传一张图片。",
    oneCoverOnly: "仅允许一张封面图片。",
    checkout: "结算",
    proceedToCheckout: "前往结算",
    completeBilling: "请在个人资料中完善账单信息。",
    creditDebitCard: "信用卡/借记卡",
    bankTransfer: "银行转账",
    cardDetails: "卡片信息",
    bankTransferInfo: "下单后，您将通过邮件收到银行转账说明。",
    placeOrder: "提交订单",
    paymentError: "无法初始化支付，请重试。",
    orderSuccess: "您的订单已成功提交。",
  },
  de: {
    about: "Über uns",
    aboutWhoTitle: "Eco Bambù: Wer sind wir",
    aboutWhoText: "Eco Bambù ist ein Hersteller und Großhändler, der auf Schals aus hochwertigen Materialien wie Wolle, Kaschmir, Leinen, Micromodal, Seide und Seidenbaumwolle spezialisiert ist. Unsere Erfahrung und unser Qualitätsanspruch machen uns zum idealen Partner für Einzelhändler und Fachleute der Modebranche.",
    aboutProductsTitle: "Unsere Produkte",
    aboutProductsIntro: "Wir bieten eine vollständige Kollektion von Schals für alle Jahreszeiten:",
    aboutProductsWinter: "Winterschals: Aus Wolle und Kaschmir, für optimalen Komfort und Schutz.",
    aboutProductsSummer: "Sommerschals: Leicht und atmungsaktiv, aus Leinen, Micromodal, Seide und Seidenbaumwolle, ideal für sommerliche Eleganz.",
    aboutWhereTitle: "Wo sind wir",
    aboutHoursTitle: "Öffnungszeiten",
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",
    cart: "Warenkorb",
    addToCart: "In den Warenkorb",
    addedToCart: "Hinzugefügt",
    cartEmpty: "Ihr Warenkorb ist leer.",
    loginToViewCart: "Bitte melden Sie sich an, um Ihren Warenkorb zu sehen.",
    requestPurchase: "Kauf anfragen",
    cartNote: "Derzeit unterstützen wir keine Online-Bestellungen.",
    contactUsHere: "Klicken Sie hier, um uns zu kontaktieren.",
    products: "Produkte",
    contact: "Kontakt",
    collection: "Unsere Kollektion",
    explore: "Entdecken",
    featured: "Ausgewählte Stücke",
    viewAll: "Alle Produkte anzeigen",
    moreInformation: "Mehr Informationen benötigt?",
    talkToUs: "Kontaktieren Sie uns",
    all: "Alle",
    allProducts: "Alle Produkte",
    filters: "Kollektionen",
    noProducts: "Keine Produkte in dieser Kollektion.",
    loading: "Laden…",
    retry: "Erneut versuchen",
    article: "Art.",
    priceOnRequest: "Preis auf Anfrage",
    madeInItaly: "Made in Italy",
    composition: "Zusammensetzung",
    color: "Farbe",
    similar: "Das könnte Ihnen auch gefallen",
    orderInfo: "Produkt anfragen",
    newsletter: "Newsletter",
    newsletterCopy: "Gelegentliche Produktneuheiten.",
    subscribe: "Abonnieren",
    email: "E-Mail-Adresse",
    subscribed: "Vielen Dank für Ihr Abonnement.",
    legal: "Rechtliches",
    howToOrder: "Bestellvorgang",
    howToOrderTitle: "Vielen Dank, dass Sie uns gewählt haben",
    howToOrderText: "Sie können Bilder, Videos oder Produktnamen per E-Mail, WeChat oder WhatsApp senden.",
    howToOrderContact: "Um unseren Kontakt hinzuzufügen, klicken Sie auf",
    privacy: "Datenschutz",
    cookies: "Cookie-Richtlinie",
    terms: "AGB",
    cookieMessage: "Wir verwenden notwendige Speicher, um Ihre Einstellungen zu merken. Optionale Analysen erfordern Ihre Zustimmung.",
    essentialOnly: "Nur notwendige",
    acceptAll: "Optionale akzeptieren",
    logIn: "Anmelden",
    signUp: "Registrieren",
    logOut: "Abmelden",
    username: "Benutzername",
    usernameOrEmail: "Benutzername oder E-Mail",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    forgotPassword: "Passwort vergessen?",
    createAccount: "Neues Konto erstellen",
    alreadyHaveAccount: "Bereits ein Konto? Anmelden",
    invalidCredentials: "Ungültiger Benutzername oder Passwort.",
    signupError: "Konto konnte nicht erstellt werden. Bitte erneut versuchen.",
    resetPassword: "Passwort zurücksetzen",
    resetDescription: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.",
    sendResetLink: "Link senden",
    resetEmailSent: "Falls ein Konto mit dieser E-Mail existiert, wurde ein Link gesendet.",
    resetError: "E-Mail konnte nicht gesendet werden. Bitte erneut versuchen.",
    backToLogin: "Zurück zur Anmeldung",
    passwordReset: "Passwort zurückgesetzt",
    passwordResetSuccess: "Ihr Passwort wurde zurückgesetzt. Sie können sich jetzt anmelden.",
    resetLinkInvalid: "Dieser Link ist ungültig oder abgelaufen.",
    confirmEmail: "E-Mail bestätigen",
    emailConfirmed: "Ihre E-Mail wurde bestätigt.",
    confirmEmailInvalid: "Dieser Bestätigungslink ist ungültig oder abgelaufen.",
    changePassword: "Passwort ändern",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    passwordChanged: "Ihr Passwort wurde geändert.",
    passwordChangeError: "Passwort konnte nicht geändert werden. Bitte erneut versuchen.",
    myAccount: "Mein Konto",
    personalData: "Persönliche Daten",
    firstName: "Vorname",
    lastName: "Nachname",
    phone: "Telefon",
    billingInformation: "Rechnungsinformationen",
    country: "Land",
    address: "Adresse",
    city: "Stadt",
    stateProvince: "Bundesland",
    postalCode: "PLZ",
    edit: "Bearbeiten",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    saveError: "Speichern fehlgeschlagen. Bitte erneut versuchen.",
    loadError: "Daten konnten nicht geladen werden.",
    wishlist: "Wunschliste",
    wishlistEmpty: "Ihre Wunschliste ist leer.",
    shippingAddress: "Lieferadresse",
    addAddress: "Adresse hinzufügen",
    setDefault: "Als Standard",
    default: "Standard",
    noAddresses: "Keine Lieferadressen.",
    orders: "Bestellungen",
    orderDetail: "Bestelldetails",
    noOrders: "Keine Bestellungen.",
    billingAddress: "Rechnungsadresse",
    paymentMethod: "Zahlungsmethode",
    status: "Status",
    orderSummary: "Bestellübersicht",
    subtotal: "Zwischensumme",
    tax: "MwSt.",
    shippingCost: "Versand",
    total: "Gesamt",
    name: "Name",
    cms: "CMS",
    productList: "Produkte",
    createProduct: "Produkt erstellen",
    editProduct: "Produkt bearbeiten",
    productAttributes: "Attribute",
    orderManagement: "Bestellverwaltung",
    productCode: "Produktcode",
    retailPrice: "Einzelhandelspreis",
    wholesalePrice: "Großhandelspreis",
    priority: "Priorität",
    category: "Kategorie",
    categories: "Kategorien",
    subcategory: "Unterkategorie",
    chooseCategory: "Kategorie wählen",
    pricePublic: "Preis sichtbar",
    compositions: "Zusammensetzungen",
    addComposition: "Zusammensetzung hinzufügen",
    description: "Beschreibung",
    images: "Bilder",
    addImages: "Bilder hinzufügen",
    checkAvailability: "Verfügbarkeit prüfen",
    available: "Verfügbar",
    spuTaken: "Bereits vergeben",
    update: "Aktualisieren",
    create: "Erstellen",
    confirmDelete: "Möchten Sie dies wirklich löschen?",
    search: "Suchen",
    searchBySpu: "Nach Produktcode suchen",
    searchByOrderNumber: "Nach Bestellnummer suchen",
    orderNumber: "Bestellnummer",
    date: "Datum",
    actions: "Aktionen",
    colors: "Farben",
    code: "Code",
    fieldRequired: "Pflichtfeld.",
    spuInvalid: "Nur Buchstaben und Zahlen erlaubt.",
    nameInvalid: "Nur - ( ) . , als Sonderzeichen erlaubt.",
    priceInvalid: "Bitte gültigen Preis eingeben.",
    imageRequired: "Mindestens ein Bild hochladen.",
    oneCoverOnly: "Nur ein Titelbild erlaubt.",
    checkout: "Kasse",
    proceedToCheckout: "Zur Kasse",
    completeBilling: "Bitte vervollständigen Sie Ihre Rechnungsinformationen in den persönlichen Daten.",
    creditDebitCard: "Kredit- / Debitkarte",
    bankTransfer: "Banküberweisung",
    cardDetails: "Kartendaten",
    bankTransferInfo: "Nach Bestellaufgabe erhalten Sie die Überweisungsdaten per E-Mail.",
    placeOrder: "Bestellung aufgeben",
    paymentError: "Zahlung konnte nicht initialisiert werden. Bitte erneut versuchen.",
    orderSuccess: "Ihre Bestellung wurde erfolgreich aufgegeben.",
  },
  ru: {
    about: "О нас",
    aboutWhoTitle: "Eco Bambù: Кто мы",
    aboutWhoText: "Eco Bambù — производитель и оптовый поставщик шарфов из высококачественных материалов: шерсти, кашемира, льна, микромодала, шёлка и шёлко-хлопка. Наш опыт и стремление к качеству делают нас идеальным партнёром для розничных продавцов и профессионалов модной индустрии.",
    aboutProductsTitle: "Наши товары",
    aboutProductsIntro: "Мы предлагаем полный ассортимент шарфов на все сезоны:",
    aboutProductsWinter: "Зимние шарфы: из шерсти и кашемира, для максимального комфорта и тепла.",
    aboutProductsSummer: "Летние шарфы: лёгкие и дышащие, из льна, микромодала, шёлка и шёлко-хлопка, идеальны для летней элегантности.",
    aboutWhereTitle: "Где мы находимся",
    aboutHoursTitle: "Часы работы",
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    friday: "Пятница",
    saturday: "Суббота",
    sunday: "Воскресенье",
    cart: "Корзина",
    addToCart: "В корзину",
    addedToCart: "Добавлено",
    cartEmpty: "Ваша корзина пуста.",
    loginToViewCart: "Войдите, чтобы увидеть корзину.",
    requestPurchase: "Запросить покупку",
    cartNote: "В настоящее время мы не поддерживаем онлайн-заказы.",
    contactUsHere: "Нажмите здесь, чтобы связаться с нами.",
    products: "Товары",
    contact: "Контакты",
    collection: "Наша коллекция",
    explore: "Просмотреть",
    featured: "Избранное",
    viewAll: "Показать все",
    moreInformation: "Нужна дополнительная информация?",
    talkToUs: "Свяжитесь с нами",
    all: "Все",
    allProducts: "Все товары",
    filters: "Коллекции",
    noProducts: "Нет товаров в этой коллекции.",
    loading: "Загрузка…",
    retry: "Повторить",
    article: "Арт.",
    priceOnRequest: "Цена по запросу",
    madeInItaly: "Сделано в Италии",
    composition: "Состав",
    color: "Цвет",
    similar: "Вам также может понравиться",
    orderInfo: "Узнать о товаре",
    newsletter: "Рассылка",
    newsletterCopy: "Редкие новости о товарах.",
    subscribe: "Подписаться",
    email: "Email",
    subscribed: "Спасибо за подписку.",
    legal: "Правовая информация",
    howToOrder: "Как заказать",
    howToOrderTitle: "Спасибо, что выбрали нас",
    howToOrderText: "Вы можете отправить фото, видео или названия интересующих товаров по Email, WeChat или WhatsApp.",
    howToOrderContact: "Чтобы добавить наш контакт, нажмите",
    privacy: "Политика конфиденциальности",
    cookies: "Политика Cookie",
    terms: "Условия использования",
    cookieMessage: "Мы используем необходимое хранилище для запоминания ваших настроек. Аналитика требует вашего согласия.",
    essentialOnly: "Только необходимые",
    acceptAll: "Принять дополнительные",
    logIn: "Войти",
    signUp: "Регистрация",
    logOut: "Выйти",
    username: "Имя пользователя",
    usernameOrEmail: "Имя пользователя или email",
    password: "Пароль",
    confirmPassword: "Подтвердите пароль",
    forgotPassword: "Забыли пароль?",
    createAccount: "Создать аккаунт",
    alreadyHaveAccount: "Уже есть аккаунт? Войти",
    invalidCredentials: "Неверное имя пользователя или пароль.",
    signupError: "Не удалось создать аккаунт. Попробуйте снова.",
    resetPassword: "Сбросить пароль",
    resetDescription: "Введите email, и мы отправим ссылку для сброса пароля.",
    sendResetLink: "Отправить ссылку",
    resetEmailSent: "Если аккаунт с таким email существует, ссылка отправлена.",
    resetError: "Не удалось отправить email. Попробуйте снова.",
    backToLogin: "Вернуться к входу",
    passwordReset: "Пароль сброшен",
    passwordResetSuccess: "Ваш пароль сброшен. Теперь вы можете войти.",
    resetLinkInvalid: "Эта ссылка недействительна или устарела.",
    confirmEmail: "Подтвердить email",
    emailConfirmed: "Ваш email подтверждён.",
    confirmEmailInvalid: "Эта ссылка недействительна или устарела.",
    changePassword: "Изменить пароль",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    passwordChanged: "Ваш пароль изменён.",
    passwordChangeError: "Не удалось изменить пароль. Попробуйте снова.",
    myAccount: "Мой аккаунт",
    personalData: "Личные данные",
    firstName: "Имя",
    lastName: "Фамилия",
    phone: "Телефон",
    billingInformation: "Платёжные данные",
    country: "Страна",
    address: "Адрес",
    city: "Город",
    stateProvince: "Регион",
    postalCode: "Индекс",
    edit: "Редактировать",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    saveError: "Не удалось сохранить. Попробуйте снова.",
    loadError: "Не удалось загрузить данные.",
    wishlist: "Избранное",
    wishlistEmpty: "Ваш список избранного пуст.",
    shippingAddress: "Адрес доставки",
    addAddress: "Добавить адрес",
    setDefault: "По умолчанию",
    default: "По умолчанию",
    noAddresses: "Нет адресов доставки.",
    orders: "Заказы",
    orderDetail: "Детали заказа",
    noOrders: "Нет заказов.",
    billingAddress: "Адрес оплаты",
    paymentMethod: "Способ оплаты",
    status: "Статус",
    orderSummary: "Итого по заказу",
    subtotal: "Подитог",
    tax: "Налог",
    shippingCost: "Доставка",
    total: "Итого",
    name: "Имя",
    cms: "CMS",
    productList: "Товары",
    createProduct: "Создать товар",
    editProduct: "Редактировать товар",
    productAttributes: "Атрибуты",
    orderManagement: "Управление заказами",
    productCode: "Код товара",
    retailPrice: "Розничная цена",
    wholesalePrice: "Оптовая цена",
    priority: "Приоритет",
    category: "Категория",
    categories: "Категории",
    subcategory: "Подкатегория",
    chooseCategory: "Выбрать категорию",
    pricePublic: "Цена видна",
    compositions: "Составы",
    addComposition: "Добавить состав",
    description: "Описание",
    images: "Изображения",
    addImages: "Добавить изображения",
    checkAvailability: "Проверить доступность",
    available: "Доступен",
    spuTaken: "Уже используется",
    update: "Обновить",
    create: "Создать",
    confirmDelete: "Вы уверены, что хотите удалить?",
    search: "Поиск",
    searchBySpu: "Поиск по коду товара",
    searchByOrderNumber: "Поиск по номеру заказа",
    orderNumber: "Номер заказа",
    date: "Дата",
    actions: "Действия",
    colors: "Цвета",
    code: "Код",
    fieldRequired: "Обязательное поле.",
    spuInvalid: "Только буквы и цифры.",
    nameInvalid: "Только - ( ) . , как спецсимволы.",
    priceInvalid: "Введите корректную цену.",
    imageRequired: "Загрузите хотя бы одно изображение.",
    oneCoverOnly: "Допускается только одно изображение обложки.",
    checkout: "Оформление заказа",
    proceedToCheckout: "Перейти к оформлению",
    completeBilling: "Пожалуйста, заполните платёжные данные в личных данных.",
    creditDebitCard: "Кредитная / дебетовая карта",
    bankTransfer: "Банковский перевод",
    cardDetails: "Данные карты",
    bankTransferInfo: "После оформления заказа вы получите реквизиты для перевода по электронной почте.",
    placeOrder: "Оформить заказ",
    paymentError: "Не удалось инициализировать оплату. Попробуйте снова.",
    orderSuccess: "Ваш заказ успешно оформлен.",
  },
};

const LanguageContext = createContext(null);

function initialLanguage() {
  const routeLanguage = window.location.pathname.split("/").filter(Boolean)[0];
  if (SUPPORTED_LANGUAGES.some(({ code }) => code === routeLanguage)) {
    return routeLanguage;
  }
  const saved = localStorage.getItem("ecobambu_language");
  return SUPPORTED_LANGUAGES.some(({ code }) => code === saved) ? saved : "en";
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(initialLanguage);

  const value = useMemo(() => {
    const setLanguage = (nextLanguage) => {
      if (!SUPPORTED_LANGUAGES.some(({ code }) => code === nextLanguage)) return;
      localStorage.setItem("ecobambu_language", nextLanguage);
      document.documentElement.lang = nextLanguage;
      setLanguageState(nextLanguage);
    };
    return {
      language,
      setLanguage,
      t: (key) => copy[language]?.[key] || copy.en[key] || key,
      pathFor: (path = "/") => `/${language}${path === "/" ? "/" : path}`,
    };
  }, [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used inside LanguageProvider");
  return context;
}
